import { useMutation, useQueryClient } from '@tanstack/react-query';
import { warehouseService } from '@services/warehouse';
import {
  MaterialCategory,
  MaterialCategoryCreateInput,
  MaterialCategoryUpdateInput,
} from '@models/warehouse.model';
import { GLOBAL_MATERIAL_CATEGORIES_QUERY_KEY } from './useGlobalMaterialCategories';
import { MATERIAL_CATEGORIES_QUERY_KEY } from './useMaterialCategories';

export const useCreateGlobalMaterialCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<MaterialCategory, Error, MaterialCategoryCreateInput>({
    mutationFn: (input) => warehouseService.createGlobalMaterialCategory(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GLOBAL_MATERIAL_CATEGORIES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATEGORIES_QUERY_KEY });
    },
  });
};

export const useUpdateGlobalMaterialCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<MaterialCategory, Error, MaterialCategoryUpdateInput>({
    mutationFn: (input) => warehouseService.updateGlobalMaterialCategory(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GLOBAL_MATERIAL_CATEGORIES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATEGORIES_QUERY_KEY });
    },
  });
};

export const useDeleteGlobalMaterialCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<{ affected: number }, Error, string>({
    mutationFn: (categoryId) => warehouseService.deleteGlobalMaterialCategory(categoryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GLOBAL_MATERIAL_CATEGORIES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATEGORIES_QUERY_KEY });
    },
  });
};
